import Dexie from "dexie";

const db = new Dexie("FoodBankERP");

db.version(1).stores({
  clients: "_id, last_name, first_name, phone, email, address",
  pendingOps: "++id, type, createdAt",
  syncMeta: "key",
});

export default db;
